import { ProcessingType } from '@/shared/models/ContextDataModel/interfaces/enums/processing-type.ts';

type Entity = {
    productGroups?: {
        orderProducts?: {
            processingType: ProcessingType;
        }[];
    }[];
    positionProductGroups?: {
        products?: {
            processingType: ProcessingType;
        }[];
    }[];
    productConfigurations?: {
        processingType: ProcessingType;
    }[];
};

// Claude suggestion for function overloading to solve ternary return type
export function getProcessingTypeFromEntity(entity: undefined): undefined;
export function getProcessingTypeFromEntity(entity: Entity): ProcessingType;
export function getProcessingTypeFromEntity(entity: Entity | undefined): ProcessingType | undefined;
export function getProcessingTypeFromEntity(entity: Entity | undefined): ProcessingType | undefined {
    if (entity?.productGroups?.[0].orderProducts?.[0]) {
        return entity.productGroups[0].orderProducts[0].processingType;
    }

    if (entity?.positionProductGroups?.[0].products?.[0]) {
        return entity.positionProductGroups[0].products[0].processingType;
    }

    if (entity?.productConfigurations?.[0]) {
        return entity.productConfigurations[0].processingType;
    }
}
